import { render, staticRenderFns } from "./ProfileEmergencyContacts.vue?vue&type=template&id=1eef1d3c&"
import script from "./ProfileEmergencyContacts.vue?vue&type=script&lang=js&"
export * from "./ProfileEmergencyContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports